import React, { useState } from 'react';
import { useNode } from '@craftjs/core';
import { useBuilderInput, useViewerContext } from '@kizen/page-builder/viewer';
import { FieldContainer } from '@kizen/page-builder/nodes/containers';
import { StyledFieldInput } from './styled';
import { definePlaceholder } from '../utils/fields';
import { useTranslation } from 'react-i18next';

const formBuilderNodeXform = (field) => {
  return {
    ...field,
    displayName: field.labelText || field.displayName,
  };
};

const builderInputXform = (field) => (value) => {
  if (field.fieldType === 'team_selector') {
    // We need to add the field_type so the form page can recognize these values
    // and convert them when submitting to the API.
    return { ...value, field_type: 'team_selector' };
  }
  if (field.fieldType === 'decimal') {
    return value !== 0 && !value ? value : value.toString();
  }
  return value;
};

export const ViewFormField = ({ field, error, ...rest }) => {
  const { t } = useTranslation();
  const { setProp } = useNode();
  const { inputValidators } = useViewerContext();
  const [value, setValue] = useBuilderInput(field.id, builderInputXform(field));
  const [innerValue, setInnerValue] = useState(value);
  const handleChange = (value, event, err) => {
    if (err) {
      setValue(value, err);
      setInnerValue(value);
      return;
    }
    const validator =
      inputValidators[field?.fieldType] ?? inputValidators.default ?? Boolean;
    if (validator(value)) {
      setProp((p) => {
        p.error = undefined;
      });
    }
    setValue(value);
    setInnerValue(value);
  };

  return (
    <FieldContainer {...rest}>
      <StyledFieldInput
        object={{}}
        field={formBuilderNodeXform(field)}
        value={innerValue ?? undefined}
        onChange={handleChange}
        source="form_field_value"
        error={error}
        placeholder={definePlaceholder(field, t)}
        isRequired={field.isRequired}
      />
    </FieldContainer>
  );
};
